<script>
import { Pie } from 'vue-chartjs';

export default {
  name: "CampaignPieStatistics",
  extends: Pie,

  data() {
    return {
      labels: [],
      datasets: [
        {
          label: 'Status',
          backgroundColor: [],
          data: []
        }
      ],
      statusColors: {
        SENT: '#68BD7B',
        QUEUED: '#3b91f1',
        SCHEDULED: '#FFCE56',
        REJECTED: '#f87979',
        INVALID: '#7a7979',
        UNSUBSCRIBED: '#ff0000',
        OPENS: '#00a9ff',
        CLICKS: '#ee02ff'
      },
      statusLabels: {
        SENT: 'Enviado',
        QUEUED: 'En Cola',
        SCHEDULED: 'Programado',
        REJECTED: 'Rechazado',
        INVALID: 'Inválido',
        UNSUBSCRIBED: 'Dado De Baja',
        OPENS: 'Opens',
        CLICKS: 'Clicks'
      }
    };
  },

  mounted() {
    this.$eventHub.$on('statisticsDataUpdated', this.updateChartWithData);
  },

  methods: {
    updateChartWithData(data) {
      this.labels = [];
      this.datasets[0].data = [];
      this.datasets[0].backgroundColor = [];

      const statusMap = {};

      data.forEach((entry) => {
        const { status, count } = entry;
        if (!statusMap[status]) {
          statusMap[status] = parseInt(count);
        } else {
          statusMap[status] += parseInt(count);
        }
      });

      Object.entries(statusMap).forEach(([status, count]) => {
        this.labels.push(this.statusLabels[status]);
        this.datasets[0].data.push(count);
        this.datasets[0].backgroundColor.push(this.statusColors[status]);
      });

      this.renderChart({
        labels: this.labels,
        datasets: this.datasets,
      }, { responsive: true, maintainAspectRatio: false });
    },
  }
}
</script>
